import React, { createContext, useContext, useState, useEffect } from 'react';

const THEME_KEY = 'itgi_theme';

const ThemeContext = createContext({
  isDark: false,
  setIsDark: () => {},
});

export function ThemeProvider({ children }) {
  const [isDark, setIsDarkState] = useState(
    () => localStorage.getItem(THEME_KEY) === 'dark'
  );

  const setIsDark = (value) => {
    setIsDarkState(value);
    localStorage.setItem(THEME_KEY, value ? 'dark' : 'light');
  };

  useEffect(() => {
    document.body.style.backgroundColor = isDark ? '#141414' : '#f0f2f5';
  }, [isDark]);

  return (
    <ThemeContext.Provider value={{ isDark, setIsDark }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
